module.exports = "<main> <div v-if=currentModule.name class=container> <h4 class=header>Introduction</h4> <p class=caption>{{{currentModule.description}}}</p> <example v-for=\"example in currentModule.examples\" :data=example></example> <properties v-if=currentModule.props.length :data=currentModule.props></properties> <methods v-if=currentModule.methods.length :data=currentModule.methods></methods> </div> </main>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/components/page-main.vue
 ** module id = 379
 ** module chunks = 0
 **/